import { cn } from "@/lib/utils";

export type BgPlacementRow = {
  id: string;
  label: string;
  hint?: string;
};

export default function BgPlacementPicker({
  placements,
  value,
  onChange,
  disabled = false,
}: {
  placements: BgPlacementRow[];
  value: string;
  onChange: (id: string) => void;
  disabled?: boolean;
}) {
  if (!placements.length) return null;
  const effective = value || "uniform";
  return (
    <div className="w-full min-w-0 space-y-1.5">
      <p className="text-xs text-muted-foreground">
        Umiejscowienie: gdzie pole ma być puste / gdzie może być znak lub światło.
      </p>
      <div className="flex flex-wrap gap-1.5">
        {placements.map((row) => {
          const active = effective === row.id;
          return (
            <button
              key={row.id}
              type="button"
              disabled={disabled}
              title={row.hint || row.label}
              className={cn(
                "rounded-md border px-2 py-1 text-left text-[11px] leading-tight transition",
                active
                  ? "border-brand bg-brand/10 font-medium text-brand"
                  : "border-input bg-card text-foreground hover:border-brand/40",
              )}
              onClick={() => onChange(row.id === "uniform" ? "" : row.id)}
            >
              {row.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
